import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import styles from './BottomNav.module.scss';

const PRIMARY_TABS = [
    { path: '/dashboard', label: 'Dashboard', icon: '◫' },
    { path: '/assets', label: 'Assets', icon: '🏦' },
    { path: '/simulator', label: 'Simulator', icon: '📈' },
    { path: '/tax', label: 'Tax', icon: '🧾' },
];

const MORE_ITEMS = [
    { path: '/cashflows', label: 'Income & Expenses', icon: '↕' },
    { path: '/goals', label: 'Goals', icon: '◎' },
    { path: '/pensions', label: 'Pensions', icon: '🏛️' },
    { path: '/healthcare-bridge', label: 'Healthcare Bridge', icon: '🏥' },
];

interface BottomNavProps {
    onThemeToggle?: () => void;
    isDarkTheme?: boolean;
}

export function BottomNav({ onThemeToggle, isDarkTheme }: BottomNavProps) {
    const [isMoreOpen, setIsMoreOpen] = useState(false);
    const { signOut } = useAuth();
    const location = useLocation();

    const isMoreActive = MORE_ITEMS.some((item) => location.pathname === item.path);

    const closeMore = () => setIsMoreOpen(false);

    return (
        <>
            {isMoreOpen && <div className={styles.backdrop} onClick={closeMore} />}

            {isMoreOpen && (
                <div className={styles.moreSheet}>
                    <div className={styles.sheetHandle} />
                    <nav className={styles.moreNav}>
                        {MORE_ITEMS.map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                className={({ isActive }) => `${styles.moreItem} ${isActive ? styles.active : ''}`}
                                onClick={closeMore}
                            >
                                <span className={styles.moreIcon}>{item.icon}</span>
                                <span className={styles.moreLabel}>{item.label}</span>
                            </NavLink>
                        ))}
                    </nav>
                    <div className={styles.sheetActions}>
                        {onThemeToggle && (
                            <button className={styles.sheetAction} onClick={onThemeToggle}>
                                <span className={styles.moreIcon}>{isDarkTheme ? '☀️' : '🌙'}</span>
                                <span className={styles.moreLabel}>{isDarkTheme ? 'Light Mode' : 'Dark Mode'}</span>
                            </button>
                        )}
                        <button className={`${styles.sheetAction} ${styles.signOut}`} onClick={signOut}>
                            <span className={styles.moreIcon}>⏻</span>
                            <span className={styles.moreLabel}>Sign Out</span>
                        </button>
                    </div>
                </div>
            )}

            <nav className={styles.bottomNav}>
                {PRIMARY_TABS.map((tab) => (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
                    >
                        <span className={styles.tabIcon}>{tab.icon}</span>
                        <span className={styles.tabLabel}>{tab.label}</span>
                    </NavLink>
                ))}
                <button
                    className={`${styles.tab} ${isMoreActive || isMoreOpen ? styles.active : ''}`}
                    onClick={() => setIsMoreOpen(!isMoreOpen)}
                >
                    <span className={styles.tabIcon}>⋯</span>
                    <span className={styles.tabLabel}>More</span>
                </button>
            </nav>
        </>
    );
}
